<div *ngIf="showBanner" class="banner">
  <div class="banner-content" [ngClass]="{'pirate-ship-font': currentPartner === 'pirate-ship'}" style="display: flex; flex-direction: column;">
    <div *ngFor="let banner of banners" class="banner1">
      <img src="../../../../assets/images/clmsIcon.png">
      <div class="text">{{ banner.messageText }}</div>
      <mat-icon class="close-icon" (click)="closeBanner()">close</mat-icon>
    </div>
  </div>
</div>